import { widthSubNav } from "@/components/layout/SubNav/SubNav";
import { LIBRARY_URL } from "@/config/api";
import { cn } from "@/lib/utils";
import { useAppSelector } from "@/redux/store";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GroupPathsEnum } from "../../constants/group.paths";
import { getPermissions } from "../../helpers/groupRole.helper";
import { useCheckRoleAndDevice } from "../../hooks/useCheckRoleAndDevice";
import { GROUP_ROUTES } from "../../routes/group.routes";

const GroupTrashScreen = () => {
  const permissions = getPermissions(GroupPathsEnum.GROUP_TRASH, GROUP_ROUTES);
  useCheckRoleAndDevice(permissions, true);

  const { data: groupInfo } = useAppSelector((state) => state.group);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [url, setUrl] = useState<string>();
  const [isShowOverlay, setIsShowOverlay] = useState<boolean>(false);
  const [postMessage, setPostMessage] = useState<MessageEvent>();

  useEffect(() => {
    if (!groupInfo) return;
    setUrl(`${LIBRARY_URL}${getCallbackUrl()}`);
  }, [location.pathname, groupInfo]);

  // Listener from iframe
  useEffect(() => {
    window.addEventListener("message", (ev: MessageEvent) => {
      setPostMessage(ev);
    });
  }, []);

  useEffect(() => {
    if (!postMessage) return;
    if (typeof postMessage.data !== "object") return;
    if (!postMessage.data.type) return;

    if (
      postMessage.data?.message === "updateURL" &&
      postMessage.data?.payload?.pathname
    ) {
      const pathnameArray: string[] =
        postMessage.data?.payload?.pathname.split("/");

      if (pathnameArray[1] === "taga-library" && pathnameArray.length === 4) {
        navigate(`/group/${id}/trash?libraryId=${pathnameArray[3]}`);
      }
    } else if (postMessage.data?.message === "showDialog" && !isShowOverlay) {
      setIsShowOverlay(true);
    } else if (postMessage.data?.message === "hiddenDialog") {
      setIsShowOverlay(false);
    }
  }, [postMessage]);

  const getCallbackUrl = () => {
    if (!groupInfo) return "";
    let callback = ``;
    callback = `/taga-library/trash/${groupInfo.libraryId}`;
    return callback;
  };

  return (
    <>
      {isShowOverlay ? (
        <div
          className={cn(
            "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          )}
          style={{ width: widthSubNav }}
        ></div>
      ) : null}
      <div className="min-h-[calc(100vh-65px)] h-[calc(100vh-65px)] w-full">
        <iframe
          id="iframeLibrary"
          className="h-full w-full"
          title={"Thùng rác"}
          src={url}
        ></iframe>
      </div>
    </>
  );
};

export default GroupTrashScreen;
